/**
 * Nom commercial, affiché dans l'interface, les emails et les pages publiques.
 * Les identifiants techniques (paquets `@bill-pulse/*`, cookies, dépôt, URL
 * actuelle) gardent l'ancien nom : les renommer ne changerait rien pour un
 * utilisateur et casserait les sessions et les liens existants.
 */
export const BRAND_NAME = 'Yakafa';
export const BRAND_TAGLINE = 'Facturation électronique et IA pour indépendants';
//# sourceMappingURL=brand.js.map